import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetProcessedCashResData } from "./GetProcessedCashResData";

const ENDPOINT = "/log_analysis/processedcash";

export class GetProcessedCashCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetProcessedCashReqData = null;

    constructor(params: GetProcessedCashReqData) {
        super();
        this.params = {...params};
    }

    public async execute(): Promise<GetProcessedCashResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetProcessedCashResData(res);
    }
}

export class GetProcessedCashReqData {
    // FilterInstallations
    installationName: string = null;
    serialNumber: string = null;
    dateStart: Date = null;
    dateEnd: Date = null;

    constructor(installationName: string, serialNumber: string, dateStart: Date, dateEnd: Date) {
        this.installationName = installationName;
        this.serialNumber = serialNumber;
        this.dateStart = dateStart;
        this.dateEnd = dateEnd;
    }
}
